"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageList = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const mailboxActions_1 = require("../store/mailboxActions");
const store_1 = require("../store");
const Message_1 = require("./message/Message");
const DateRow_1 = require("./DateRow");
const ConversationWebSocketChannel_1 = require("./webSocket/ConversationWebSocketChannel");
const LoadMoreMessagesHeader_1 = require("./LoadMoreMessagesHeader");
const perPage = 30;
const MessageList = ({ linkPreviewAPIUrl, loadMessages: loadMessagesProp, openUrl, ownProfileGid, renderImageGallery, }) => {
    const dispatch = react_redux_1.useDispatch();
    const scrollRef = react_1.useRef(null);
    const messages = store_1.useMessages();
    const meta = store_1.useMessagesMeta();
    const isLoading = store_1.useMessagesAreLoading();
    const currentConversationId = store_1.useCurrentConversationId();
    const loadMessages = react_1.useCallback((page) => {
        if (!currentConversationId) {
            return;
        }
        // Errors are (should be) handled and logged in the api of the client already
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadMessagesProp(currentConversationId, page, perPage).then((messagesPayload) => {
            if (messagesPayload) {
                dispatch(mailboxActions_1.addMessages({
                    conversationId: currentConversationId,
                    messagesPayload,
                }));
            }
        });
    }, [currentConversationId, dispatch, loadMessagesProp]);
    const renderItem = react_1.useCallback(({ item }) => {
        // You: Wait, are you building your own section list with a scroll view here?
        // Me: Yeah, kind of. I had many issues finding a stable solution for the
        //     scroll behavior. In the app there is no issue, but in the web there is.
        //     As there are multiple issues on GitHub for scrolling in RNW , this
        //     will hopefully become better in the future :)
        return (react_1.default.createElement(react_native_1.View, { key: item.id },
            !item.previousMessageIsSameDay ? (react_1.default.createElement(DateRow_1.DateRow, { date: item.createdAt })) : null,
            react_1.default.createElement(Message_1.Message, { linkPreviewAPIUrl: linkPreviewAPIUrl, message: item, renderImageGallery: renderImageGallery, openUrl: openUrl })));
    }, [linkPreviewAPIUrl, openUrl, renderImageGallery]);
    react_1.useEffect(() => {
        dispatch(mailboxActions_1.setOwnProfileGid({ ownProfileGid }));
    }, [dispatch, ownProfileGid]);
    react_1.useEffect(() => {
        loadMessages(1);
    }, [loadMessages]);
    react_1.useEffect(() => {
        var _a;
        if (!isLoading && (meta === null || meta === void 0 ? void 0 : meta.currentPage) === 1) {
            (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd({ animated: false });
            setTimeout(() => {
                var _a;
                (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd({ animated: false });
            }, 10);
        }
    }, [isLoading, meta === null || meta === void 0 ? void 0 : meta.currentPage, messages]);
    ConversationWebSocketChannel_1.useConversationWebSocketChannel();
    return (react_1.default.createElement(react_native_1.ScrollView, { ref: scrollRef, style: [styles.list] },
        react_1.default.createElement(LoadMoreMessagesHeader_1.LoadMoreMessagesHeader, { loadMessages: loadMessages }),
        messages.map((message, index) => renderItem({ index, item: message }))));
};
exports.MessageList = MessageList;
const styles = react_native_1.StyleSheet.create({
    backgroundImage: {
        bottom: 8,
        height: '50%',
        left: 8,
        position: 'absolute',
        right: 8,
    },
    list: {
        flex: 1,
        maxHeight: 700,
        overflow: 'hidden',
        paddingHorizontal: 15,
    },
});
